import { render, staticRenderFns } from "./PushNotifications.vue?vue&type=template&id=6f54886f&scoped=true&"
import script from "./PushNotifications.vue?vue&type=script&lang=js&"
export * from "./PushNotifications.vue?vue&type=script&lang=js&"
import style0 from "./PushNotifications.vue?vue&type=style&index=0&id=6f54886f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54886f",
  null
  
)

export default component.exports